import FooterLayout from '../../../../components/FooterLayout';
import Button from '../../../../components/common/Button';
import styles from './styles.module.css';
import { FormEventHandler, ReactNode } from 'react';

type Props = {
  children?: ReactNode;
  onSubmit?: FormEventHandler;
  onCancel?: () => void;
};

function Form({ children, onSubmit, onCancel }: Props) {
  return (
    <form className={styles.host} onSubmit={onSubmit}>
      <FooterLayout
        main={<div className={styles.main}>{children}</div>}
        footer={
          <div className={styles.formButtons}>
            <Button
              type="button"
              variants={['cancel', 'large']}
              onClick={onCancel}
            >
              キャンセル
            </Button>
            <Button variants={['large']}>確定</Button>
          </div>
        }
      />
    </form>
  );
}

export default Form;
